import React from "react";
import { KrakenDropdown } from "./Desktop/KrakenDropdown";
import { NavLinkBase } from "./NavLinkBase";
import { IKrakenNavLink } from "./interfaces";

export const NavLink = (props: IKrakenNavLink) => {
  const { linkConfig } = props;
  const { dropdownList, name } = linkConfig;

  if (!dropdownList) {
    return <NavLinkBase {...props} />;
  }

  return (
    <KrakenDropdown id={`${name}-dropdown`} dropdownList={dropdownList}>
      <NavLinkBase {...props} />
    </KrakenDropdown>
  );
};
